/*
 * FLIQA — "Birlikte Al" kartları (extended ürün sayfası).
 *
 * Temanın kendi toplu ekleme mantığına DOKUNMAZ; sadece taslakta istenen
 * kart başına kontrolleri ekler:
 *   - görünür miktar kutusu (−/+), temanın .js-input-quantity alanını sürer
 *   - "Ürün Kodu" ve "Min. Sipariş" satırları (varyant değişince güncellenir)
 *   - kart başına "Sepete Ekle" butonu
 *
 * MOQ kaynağı: #fliqa-moq-rules (snippets/moq-rules.liquid) — SKU bazlı.
 * Kural yoksa minimum 1, adım 1.
 */
(function () {
  'use strict';

  function rules() {
    var el = document.getElementById('fliqa-moq-rules');
    if (!el) return {};
    try {
      var data = JSON.parse(el.textContent);
      return data && typeof data === 'object' ? data : {};
    } catch (err) {
      return {};
    }
  }

  var RULES = rules();

  function ruleFor(sku) {
    var r = sku ? RULES[String(sku).trim()] : null;
    var moq = r ? parseInt(r.moq, 10) : 1;
    var step = r ? parseInt(r.step, 10) : 1;
    if (!(moq > 0)) moq = 1;
    if (!(step > 0)) step = moq > 1 ? moq : 1;
    return { moq: moq, step: step };
  }

  function selectedOption(card) {
    var sel = card.querySelector('.select-master-bundle');
    if (!sel) return null;
    return sel.options[sel.selectedIndex] || null;
  }

  function skuOf(card) {
    var opt = selectedOption(card);
    if (opt && opt.getAttribute('data-option-sku')) return opt.getAttribute('data-option-sku');
    var out = card.querySelector('[data-fq-bundle-sku]');
    return out ? out.textContent.trim() : '';
  }

  function qtyInput(card) {
    return card.querySelector('.js-input-quantity');
  }

  /* Kartın metin satırlarını ve miktar alt sınırını seçili varyanta göre tazele. */
  function refresh(card, resetQty) {
    var sku = skuOf(card);
    var rule = ruleFor(sku);

    var skuOut = card.querySelector('[data-fq-bundle-sku]');
    if (skuOut) skuOut.textContent = sku || '—';

    var moqOut = card.querySelector('[data-fq-bundle-moq]');
    if (moqOut) moqOut.textContent = rule.moq;

    card.setAttribute('data-fq-moq', rule.moq);
    card.setAttribute('data-fq-step', rule.step);

    var input = qtyInput(card);
    if (!input) return;
    var current = parseInt(input.value, 10);
    /* 0 = temanın "bu ürün seçili değil" durumu, ona dokunma. */
    if (current === 0 && !resetQty) return;
    if (resetQty || isNaN(current) || current < rule.moq) {
      input.value = rule.moq;
    }
  }

  function step(card, dir) {
    var input = qtyInput(card);
    if (!input) return;
    var moq = parseInt(card.getAttribute('data-fq-moq'), 10) || 1;
    var stp = parseInt(card.getAttribute('data-fq-step'), 10) || 1;
    var current = parseInt(input.value, 10);
    if (isNaN(current) || current < moq) current = moq;
    var next = dir === '+' ? current + stp : current - stp;
    if (next < moq) next = moq;
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setPending(btn, on) {
    if (on) {
      btn.setAttribute('data-pending', '');
      btn.disabled = true;
    } else {
      btn.removeAttribute('data-pending');
      btn.disabled = false;
    }
  }

  function flash(btn, text) {
    var original = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', original);
    btn.textContent = text;
    setTimeout(function () { btn.textContent = btn.getAttribute('data-label'); }, 1800);
  }

  function addToCart(card, btn) {
    var input = qtyInput(card);
    var opt = selectedOption(card);
    var id = opt ? opt.value : (input && input.getAttribute('data-variant-id'));
    var moq = parseInt(card.getAttribute('data-fq-moq'), 10) || 1;
    /* Alan boş/hatalı bırakılmışsa önce ekranda da düzelt, sonra gönder. */
    if (input) sanitize(input, card, true);
    var qty = parseInt(input && input.value, 10);
    if (isNaN(qty) || qty < moq) qty = moq;
    if (!id) return;

    /* Temanın kendi Cart.add akışıyla birebir aynı istek: tek ürün + "ajax-cart"
       bölümü. Dönen cevap hem satır kalemini hem sections'ı içerdiği için
       başlıktaki mini sepet de aynı ana butondaki gibi güncelleniyor. */
    var body = new FormData();
    body.append('id', id);
    body.append('quantity', qty);
    body.append('sections', 'ajax-cart');
    if (window.theme && theme.routes && theme.routes.searchUrl) {
      body.append('sections_url', theme.routes.searchUrl);
    }

    setPending(btn, true);
    fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: new Headers({ 'X-Requested-With': 'XMLHttpRequest' }),
      body: body
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          flash(btn, 'Eklenemedi');
          return;
        }
        flash(btn, 'Eklendi ✓');
        if (res.data && res.data.sections) {
          document.dispatchEvent(new CustomEvent('cart-add', { detail: res.data }));
        }
        /* Başlık sayacı ve ücretsiz kargo çubuğu bu olayla güncelleniyor. */
        return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (window.Cart) Object.assign(window.Cart, cart);
            document.dispatchEvent(new CustomEvent('cart-change', { detail: cart }));
          });
      })
      .catch(function () { flash(btn, 'Eklenemedi'); })
      .finally(function () { setPending(btn, false); });
  }

  /* Miktar alanı temada type="text" — rakam dışında her şey (harf, eksi, boşluk)
     yazılabiliyordu. Girişi rakama indirger, alt sınırı MOQ'ya sabitler. */
  function sanitize(input, card, final) {
    var moq = parseInt(card.getAttribute('data-fq-moq'), 10) || 1;
    var raw = String(input.value);
    var cleaned = raw.replace(/[^0-9]/g, '');
    if (final) {
      var n = parseInt(cleaned, 10);
      /* Boş/geçersiz bırakılırsa MOQ'ya çekilir; MOQ'nun altı da MOQ'ya
         yuvarlanır. Müşteri elle istediği (MOQ ve üzeri) değeri girebilir. */
      if (isNaN(n) || n < moq) n = moq;
      if (String(n) !== raw) input.value = n;
    } else if (cleaned !== raw) {
      /* Sadece gerçekten rakam dışı bir karakter yazıldıysa alana dokun —
         aksi halde imleç sürekli sona atlıyordu. */
      input.value = cleaned;
    }
  }

  function init() {
    var cards = document.querySelectorAll('.bundled-card');
    if (!cards.length) return;

    for (var i = 0; i < cards.length; i++) {
      refresh(cards[i], true);
      /* Tema alanı type="text" basıyor: mobilde harf klavyesi açılıyordu ve
         ekran okuyucu için etiketi yoktu. */
      var qi = qtyInput(cards[i]);
      if (qi) {
        qi.setAttribute('inputmode', 'numeric');
        qi.setAttribute('autocomplete', 'off');
        if (!qi.getAttribute('aria-label')) qi.setAttribute('aria-label', 'Miktar');
      }
    }

    /* Miktar alanında Enter, #bundledAddToCart formunu POST edip kullanıcıyı
       /cart sayfasına atıyordu. Bu formun artık görünür bir gönder butonu yok. */
    var bundleForm = document.getElementById('bundledAddToCart');
    if (bundleForm) {
      bundleForm.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) e.preventDefault();
      });
      bundleForm.addEventListener('submit', function (e) { e.preventDefault(); });
    }

    document.addEventListener('input', function (e) {
      if (!e.target.matches || !e.target.matches('.bundled-card .js-input-quantity')) return;
      var c = e.target.closest('.bundled-card');
      if (c) sanitize(e.target, c, false);
    });

    ['blur', 'change'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.target.matches || !e.target.matches('.bundled-card .js-input-quantity')) return;
        var c = e.target.closest('.bundled-card');
        if (c) sanitize(e.target, c, true);
      }, true);
    });

    document.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-fq-bqty]');
      if (stepBtn) {
        e.preventDefault();
        var c = stepBtn.closest('.bundled-card');
        if (c) step(c, stepBtn.getAttribute('data-fq-bqty'));
        return;
      }
      var addBtn = e.target.closest('[data-fq-bundle-add]');
      if (addBtn) {
        e.preventDefault();
        var card = addBtn.closest('.bundled-card');
        if (card) addToCart(card, addBtn);
      }
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('.select-master-bundle')) return;
      var card = e.target.closest('.bundled-card');
      /* Temanın kendi handler'ı fiyat/id güncellemesini aynı olayda yapıyor,
         bizimki sonra çalışsın diye bir tick bekliyoruz. */
      if (card) setTimeout(function () { refresh(card, true); }, 0);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
